import React, { useState, useEffect } from 'react';
import './praktiskpriser.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Funktion til at håndtere både markdown og HTML-indhold
const prepareContent = (content) => {
  if (!content) return '';

  // Hvis teksten allerede er HTML (fra rich text editor)
  if (content.includes('<p>') || content.includes('<h') || content.includes('<ul>') || 
      content.includes('<strong>') || content.includes('<u>') || content.includes('<a ')) {
    // Vi beholder HTML som den er, da formatering håndteres korrekt i rich text editor
    return content;
  }

  // Hvis det er markdown eller plain text
  // Konverter overskrifter
  let html = content.replace(/^## (.*?)$/gm, '<h3>$1</h3>');

  // Konverter fed tekst
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Konverter bullet points
  html = html.replace(/^- (.*?)$/gm, '<li>$1</li>');
  
  // Del teksten på dobbelte linjeskift, hvilket normalt indikerer nye afsnit
  const paragraphs = html.split(/\n\s*\n/); // Split ved tomme linjer
  html = paragraphs.map(p => {
    const trimmedP = p.trim();
    if (trimmedP === '') return '';
    
    // Håndter lister
    if (trimmedP.includes('<li>')) {
      return `<ul>${trimmedP}</ul>`;
    }
    
    // Håndter overskrifter
    if (trimmedP.includes('<h3>')) {
      return trimmedP;
    }
    
    // Almindelige afsnit - bevar enkelte linjeskift som mellemrum
    return `<p>${trimmedP.replace(/\n/g, ' ')}</p>`;
  }).join('\n\n'); // Tilføj afstand mellem afsnit

  return html;
};

const PraktiskPriser = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [praktiskData, setPraktiskData] = useState({
    title: 'Praktisk & Priser',
    heroImage: '/media/BF4A2BE8-2CB0-4540-B2FD-87C59E7E67CA.jpg',
    textBefore: '',
    locationImage: '/media/perspektiv-lokation.avif',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.484931924789!2d12.5903163159283!3d55.68268098053369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465253764030803b%3A0xf12e177be3965413!2sSankt%20Ann%C3%A6%20Plads%2012%2C%201250%20K%C3%B8benhavn!5e0!3m2!1sda!2sdk!4v1645541234567!5m2!1sda!2sdk',
    textAfter: ''
  });

  useEffect(() => {
    const fetchPraktiskData = async () => {
      try {
        const praktiskDocRef = doc(db, 'content', 'praktiskPriser');
        const praktiskDoc = await getDoc(praktiskDocRef);
        
        if (praktiskDoc.exists()) {
          const data = praktiskDoc.data();
          setPraktiskData({
            title: data.title || 'Praktisk & Priser',
            heroImage: data.heroImage || '/media/BF4A2BE8-2CB0-4540-B2FD-87C59E7E67CA.jpg',
            textBefore: data.textBefore || '',
            locationImage: data.locationImage || '/media/perspektiv-lokation.avif',
            mapEmbedUrl: data.mapEmbedUrl || 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.484931924789!2d12.5903163159283!3d55.68268098053369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465253764030803b%3A0xf12e177be3965413!2sSankt%20Ann%C3%A6%20Plads%2012%2C%201250%20K%C3%B8benhavn!5e0!3m2!1sda!2sdk!4v1645541234567!5m2!1sda!2sdk',
            textAfter: data.textAfter || ''
          });
        }
      } catch (error) {
        console.error('Fejl ved hentning af praktisk/priser data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPraktiskData();
  }, []);

  if (isLoading) {
    return <div className="praktisk-loading">Indlæser...</div>;
  }

  return (
    <div className="praktisk-priser-container">
      <section className="praktisk-hero-section">
        <h1>{praktiskData.title}</h1>
        <div className="praktisk-hero-image-container">
          <img 
            src={praktiskData.heroImage} 
            alt="Psykologisk Perspektiv" 
            className="praktisk-hero-image"
          />
        </div>
      </section>

      <div className="praktisk-content-box">
        <div className="praktisk-content-text" dangerouslySetInnerHTML={{ __html: prepareContent(praktiskData.textBefore) }} />
      </div>

      <div className="praktisk-image-map-container">
        <div className="praktisk-klinik-billede">
          <img 
            src={praktiskData.locationImage} 
            alt="Klinikkens indgang" 
          />
        </div>
        <div className="praktisk-google-maps">
          <iframe
            src={praktiskData.mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps"
          ></iframe>
        </div>
      </div>

      <div className="praktisk-content-box">
        <div className="praktisk-content-text" dangerouslySetInnerHTML={{ __html: prepareContent(praktiskData.textAfter) }} />
      </div>
    </div>
  );
};

export default PraktiskPriser;
